import React, { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { ErrorCode } from '@ancon/wildcat-types'

import HeadingText from '../../app/components/HeadingText'
import useAppSelector from '../../../store/hooks/useAppSelector'
import { appErrorModalConfigSelector } from '../../app/store/appSelectors'
import { currentCheckoutItemsSelector } from '../store/checkoutSelectors'
import { InformativeError } from '../../app/types'
import { clientContextIsCompanyUserSelector } from '../../clientContext/store/clientContextSelectors'

import styles from './CheckoutItemsOverrideMenuConflictList.module.scss'

type OverrideMenuErrorConfig =
  InformativeError<ErrorCode.CheckoutItemUnavailableDueToOverrideMenu> | null

export default function CheckoutItemsOverrideMenuConflictList() {
  const { t } = useTranslation('common')

  const overrideMenuErrorConfig: OverrideMenuErrorConfig = useAppSelector(
    appErrorModalConfigSelector,
  )
  const isCompanyUser = useAppSelector(clientContextIsCompanyUserSelector)
  const currentCheckoutItems = useAppSelector(currentCheckoutItemsSelector)

  const productNameMap = useMemo(
    () =>
      currentCheckoutItems.reduce<Record<string, string>>((acc, item) => {
        acc[item.product.variantId] = item.product.hasVariants
          ? item.product.variantName
          : item.product.name
        return acc
      }, {}),
    [currentCheckoutItems],
  )

  return (
    <div className={styles.unavailableProductsList}>
      <HeadingText
        as="h3"
        size="h3"
        className={styles.unavailableProductsTitle}
      >
        {!isCompanyUser
          ? t('errors.unAvailableItemDueToOverrideMenu.notInCurrentMenuMessage')
          : t('errors.unAvailableItemDueToOverrideMenu.companyOnlyMessage')}
      </HeadingText>
      <ul className={styles.productList}>
        {overrideMenuErrorConfig?.additionalData?.checkoutItemProductVariantIds.map(
          productId => (
            <li key={productId} className={styles.productItem}>
              {productNameMap[productId]}
            </li>
          ),
        )}
      </ul>
    </div>
  )
}
